export function normalizeSmsResults(payload) {
  if (Array.isArray(payload)) {
    return Object.fromEntries(payload.filter(item => item && item.to).map(item => [item.to, item]));
  }
  return payload && typeof payload === 'object' ? payload : {};
}
export function smsResultSummary(results) {
  const items = Object.values(results);
  const success = items.length > 0 && items.every(item => item.status === true);
  const messages = items.map(item => item.historyWarning || item.error?.message).filter(Boolean);
  return { success, message: [...new Set(messages)].join(' ') || (success ? '' : 'Message could not be sent. Check the recipient and try again.') };
}
